// extracted by mini-css-extract-plugin
export default {"table":"table_table__H5EI5","row":"table_row__5c3GU","actions":"table_actions__GVNaQ","small":"table_small__eJByP"};